function VideoIcon() {
  return (
    <svg 
      width="24"
      height="40"
      viewBox="0 0 24 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M22.8332 20L1.63982 1.59541L1.63982 38.4047L22.8332 20Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default VideoIcon
